import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

import queryString from 'query-string';

/**
 * Get Form Redirect URL
 *
 * Here is a helper function to get the redirect url to redirect users
 * after successful login/register
 *
 * If coming from checkout, a checkout_url query param is added to url
 *  Use that to redirect back to checkouit
 * else if on an account page (or account/login, account/register), redirect to account page
 *
 * else, redirect to the page user is currently on
 *
 * @param none (uses window.location object)
 * @return {string} redirect url
 */
export var getFormRedirectUrl = function getFormRedirectUrl() {
  var checkoutQuery = queryString.parse(window.location.search).checkout_url;
  if (checkoutQuery) {
    return checkoutQuery;
  } else if (window.location.pathname.includes('/account')) {
    return '/account';
  } else {
    return window.location.pathname + window.location.search;
  }
};
/**
 * Set Cookie
 *
 * Here is a helper function to set a cookie in browser
 *
 * pass in cookie key, value and expiry (in days)
 *
 * @param {string} key - name of cookie key setting
 * @param {string} value - name of cookie value setting
 * @param {number} days - amount of days till it expires
 *
 * @return {string} value
 */
export var setCookie = function setCookie(key, value, days) {
  var date = new Date();
  // Default at 365 days.
  days = days || 365;
  // Get unix milliseconds at current time plus number of days
  date.setTime(+date + days * 86400000); //24 * 60 * 60 * 1000
  window.document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
  return value;
};

/**
 * Get Cookie
 *
 * Here is a helper function to get a cookie from browser
 * Its a wild func that works. ¯\_(ツ)_/¯
 *
 * @param {string} name - name of cookie searching for
 *
 * @return {string} cookie
 */
export var getCookie = function getCookie(name) {
  if (typeof document === 'undefined') return ''; // send empty string to dataWarehouse if doesn't exist
  var cookie = document.cookie;
  var setPos = cookie.search(new RegExp('\\b' + name + '='));
  var stopPos = cookie.indexOf(';', setPos);
  var res;
  if (!~setPos) return ''; // send empty string to dataWarehouse if doesn't exist
  res = decodeURIComponent(cookie.substring(setPos, ~stopPos ? stopPos : undefined).split('=')[1]);
  return res.charAt(0) === '{' ? JSON.parse(res) : res;
};

/**
 * Get Cookies
 *
 * here is a helper function to get all cookies needed for formik forms
 *
 * @return {object} cookies
 */
export var getCookies = function getCookies() {
  return {
    dyKey: getCookie('_dyid'),
    gaKey: getCookie('_ga'),
    zaiusKey: getCookie('z_customer_id'),
    swymKey: getCookie('swym-pid'),
    shopifyKey: window.Dormify.customerId,
    attentiveKey: getCookie('__attentive_id')
  };
};

/**
 *
 * Remove Cookie
 *
 * Removes cookie by taking name, setting value as blank,
 * and setting expiration to past date.
 */

export var removeCookie = function removeCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

/**
 * Contact Validation
 *
 * Used to validate formik forms
 * validate phone number
 * validate email
 * validate required
 *
 * @param {object} values - form values
 *
 * @return {object} errors
 */
export var contactValidation = function contactValidation(values, dyAllFieldsRequiredFlag) {
  var errors = {};
  if (values.contactMethod === 'sms' && !values.phone) {
    errors.phone = 'Required';
  }
  if (values.contactMethod === 'email' && !values.email) {
    errors.email = 'Required';
  }
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (values.phone && !/^[0-9]{3}[-]?[0-9]{3}[-]?[0-9]{4,6}$/i.test(values.phone)) {
    errors.phone = 'Invalid phone number';
  }

  // add condition here for DY A/B Testing
  if (dyAllFieldsRequiredFlag) {
    if (!values.gender) {
      errors.gender = 'Required';
    }
    if (!values.person) {
      errors.person = 'Required';
    }
    if (!values.graduationYear) {
      errors.graduationYear = 'Required';
    }
  }
  return errors;
};

/**
 * Phone Number Mask
 *
 * only allow numbers
 * always format 333-333-3333
 */
export var phoneNumberMask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

/**
 * Post Data to Warehouse (async)
 *
 * Alright this is where all the magic happens
 *
 * Take the data from the form
 *
 * Submit it to data-capture service
 *
 * wait for response
 *
 * if 409 status => error!
 *    Show error message
 *
 * if 200 status => success!
 *    Show success, hide form, add discount code, and add submit cookie
 *
 * always setSubmitting to false
 *
 * return response
 *
 * @param {object} data - form data
 * @param {bool} setSubmitting
 * @param {element} errorRef - errorRef.current
 * @param {element} formRef - formRef.current
 * @param {element} successRef - successRef.current
 * @param {func} handleFormSubmitDiscountCode - func to add discount code. passed from App.js
 * @param {element} hideElementOnSuccess - incase you need to hide another element (footer form)
 * @param {string} redirectLocation - redirect to other page on successful submission (Data Capture landing page)
 * @param {bool} isModal - check if modal, if modal, don't redirect after submission
 * @param {bool} isFooter - check if modal, if modal, don't redirect after submission
 *
 * @return {object} response
 */
export var postDataToWarehouse = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data,
        setSubmitting = _ref2.setSubmitting,
        errorRef = _ref2.errorRef,
        formRef = _ref2.formRef,
        successRef = _ref2.successRef,
        handleFormSubmitDiscountCode = _ref2.handleFormSubmitDiscountCode,
        hideElementOnSuccess = _ref2.hideElementOnSuccess,
        setIsSmsSubmission = _ref2.setIsSmsSubmission,
        redirectLocation = _ref2.redirectLocation,
        isModal = _ref2.isModal;
    var response, resJson;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch('https://dormify-datacapture-service-33tdfxk4ua-ue.a.run.app/api/formcapture/v1/submit', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data) // body data type must match "Content-Type" header
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            resJson = _context.sent;
            // parses JSON response into native JavaScript objects
            if (response.status === 409) {
              // error
              errorRef && resJson.message && (errorRef.innerText = resJson.message);
            } else if (response.status === 200) {
              // success
              if (data.contactMethod === 'email') {
                // if email, auto add form.
                handleFormSubmitDiscountCode();
              } else {
                // if sms, user is sent sms with discount code
                setIsSmsSubmission(true);
              }
              isModal && formRef && (formRef.style.display = 'none');
              successRef && (successRef.style.display = 'block');
              console.log('SUCCESS REF: ', successRef);
              // sometimes you gotta hide extra stuff so added this
              hideElementOnSuccess && (hideElementOnSuccess.style.display = 'none');
              setCookie('dormify_modal_form_submitted', true, 365);
              DY.API('event', {
                name: 'data_capture_submit',
                properties: {
                  gender: data.gender,
                  person: data.person,
                  graduationYear: data.graduationYear
                }
              });

              redirectLocation && redirectLocation !== '' && setTimeout(function () {
                window.location.replace(redirectLocation);
              }, 10000);
              // Redirect after 10 sec
            }
            setSubmitting(false);
            return _context.abrupt('return', response);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function postDataToWarehouse(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Array From Range
 *
 * pass in a start, end and step variables and an array of those numbers
 * will be returned. Used to create array for graduation years
 * @param {Number} start - start of range (ie. 2000)
 * @param {Number} ebd - end of range (ie. 2005)
 * @param {Number} step - step to increment from (ie. 1)
 *
 * @return {Array} Array of numbers (ie. [2000, 2001, 2002, 2003, 2004, 2005])
 */
export var arrayFromRange = function arrayFromRange(start, end, step) {
  return Array.from(Array.from(Array(Math.ceil((end - start + 1) / step)).keys()), function (x) {
    return start + x * step;
  });
};

/**
 * Get Graduation Year Select Options
 *
 * Need to build the Grad year select option array
 * First add disabled placeholder
 * then before start range
 * then the grad year range
 * then prefer not to say option
 *
 * @return {Array} Array of objects for Grad year select
 */
export var getGraduationYearSelectOptions = function getGraduationYearSelectOptions() {
  var currentYear = new Date().getFullYear();
  var startRange = currentYear;
  var endRange = currentYear + 5;

  var graduationYearRange = arrayFromRange(startRange, endRange, 1).reverse();
  // add base options
  var options = [{ value: '', label: 'Select year', disabled: true }, {
    value: '1000',
    label: 'I\u2019m in middle school'
  }, {
    value: '2000',
    label: 'I\u2019m in high school (NOT a senior)'
  }];
  // add graduationYearRange options
  graduationYearRange.map(function (year) {
    return options.push({ value: '' + year, label: '' + year });
  });
  // add after endRange option
  options.push({
    value: '3000',
    label: currentYear - 1 + ' or earlier'
  });
  // add na option
  options.push({ value: '0000', label: 'Prefer not to say' });

  return options;
};